import React from "react";
import { COLORS } from "../constants";

/* =======================
   HEADER CONFIG (ONLY CHANGE)
======================= */

export const ADDITIONAL_RAC_HEADERS = [
  "ruleType",
  "fromScore",
  "toScore",
  "minAge",
  "maxAge",
  "minTenure",
  "maxTenure",
  "minNetSalary",
  "minTermOfService",
  "minFinanceAmount",
  "maxFinanceAmount",
  "profitRate",
  "package",
] as const;

type AdditionalRacHeaderKey = (typeof ADDITIONAL_RAC_HEADERS)[number];

const ADDITIONAL_RAC_HEADER_LABELS: Record<AdditionalRacHeaderKey, string> = {
  ruleType: "Rule Type",
  fromScore: "From Score",
  toScore: "To Score",
  minAge: "Minimum Age",
  maxAge: "Maximum Age",
  minTenure: "Min Tenure",
  maxTenure: "Max Tenure",
  minNetSalary: "Min Net Salary",
  minTermOfService: "Min Term Of Service",
  minFinanceAmount: "Min Finance Amount",
  maxFinanceAmount: "Max Finance Amount",
  profitRate: "Profit Rate",
  package: "Package",
};

/* =======================
   TYPES
======================= */

type AdditionalRacRow = {
  ruleType: string;
  fromScore: string | number;
  toScore: string | number;
  minAge: string | number;
  maxAge: string | number;
  minTenure: string | number;
  maxTenure: string | number;
  minNetSalary: string | number;
  minTermOfService: string | number;
  minFinanceAmount: string | number;
  maxFinanceAmount: string | number;
  profitRate: string | number;
  package: string;
};

interface DataProps {
  data?: Partial<AdditionalRacRow>;
}

/* =======================
   COMPONENT
======================= */

const ProvenirAdditionalRacDetails: React.FC<DataProps> = ({ data }) => {
  const row: AdditionalRacRow = {
    ruleType: data?.ruleType ?? "-",
    fromScore: data?.fromScore ?? "-",
    toScore: data?.toScore ?? "-",
    minAge: data?.minAge ?? "-",
    maxAge: data?.maxAge ?? "-",
    minTenure: data?.minTenure ?? "-",
    maxTenure: data?.maxTenure ?? "-",
    minNetSalary: data?.minNetSalary ?? "-",
    minTermOfService: data?.minTermOfService ?? "-",
    minFinanceAmount: data?.minFinanceAmount ?? "-",
    maxFinanceAmount: data?.maxFinanceAmount ?? "-",
    profitRate: data?.profitRate ?? "-",
    package: data?.package ?? "-",
  };

  return (
    <div className="container mt-4">
      <table className="table text-center table-border spaced-table">
        {/* HEADER */}
        <thead style={{ background: "#F8F8F8" }}>
          <tr style={{ color: COLORS.TEXT_MUTED }}>
            {ADDITIONAL_RAC_HEADERS.map((key) => (
              <th key={key}>{ADDITIONAL_RAC_HEADER_LABELS[key]}</th>
            ))}
          </tr>
        </thead>

        {/* BODY */}
        <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "small" }}>
          <tr>
            {ADDITIONAL_RAC_HEADERS.map((key) => (
              <td key={key}>{row[key]}</td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ProvenirAdditionalRacDetails;
